import React from 'react';
import clsx from 'clsx';
import './List.less';

export type ListVariant = 'bordered' | 'flush';

interface Props {
  children: React.ReactNode;
  className?: string;
  variant?: ListVariant;
}

export default function List({
  children,
  className,
  variant = 'bordered',
}: Props) {
  return (
    <ul
      className={clsx(
        'base-list',
        {
          'base-list--bordered': variant === 'bordered',
          'base-list--flush': variant === 'flush',
        },
        className,
      )}
    >
      {children}
    </ul>
  );
}
